import React, { useRef } from 'react';
import classNames from 'classnames/bind';
import { cnTheme } from '@carnica/themes';
import { useHeaderIndent } from "../../hooks/useHeaderIndent";
import { useBackdropFilter } from "../../hooks/useBackdropFilter";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var Section = function Section(_ref) {
  var className = _ref.className,
    gap = _ref.gap,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? 'equal-columns' : _ref$view,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("section", {
    className: cn('section', "section__gap--".concat(gap), "section__view--".concat(view), className)
  }, children);
};
var Wrapper = function Wrapper(_ref2) {
  var className = _ref2.className,
    _ref2$position = _ref2.position,
    position = _ref2$position === void 0 ? 'center' : _ref2$position,
    _ref2$gap = _ref2.gap,
    gap = _ref2$gap === void 0 ? 'm' : _ref2$gap,
    fullWidth = _ref2.fullWidth,
    children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper', "wrapper__position--".concat(position), "wrapper__gap--".concat(gap), {
      wrapper__fullWidth: fullWidth
    }, className)
  }, children);
};
var Container = function Container(_ref3) {
  var className = _ref3.className,
    children = _ref3.children,
    _ref3$position = _ref3.position,
    position = _ref3$position === void 0 ? 'fixed' : _ref3$position,
    headerTheme = _ref3.headerTheme;
  var elementRef = useRef(null);
  useHeaderIndent(elementRef, headerTheme);
  useBackdropFilter(elementRef);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('container', "container-theme--".concat(headerTheme), "container-position--".concat(position), className),
    "data-component": "site-header-container",
    ref: elementRef
  }, children);
};
var Indent = function Indent(_ref4) {
  var className = _ref4.className,
    children = _ref4.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('indent', className)
  }, children);
};
export var Layout = function Layout(_ref5) {
  var className = _ref5.className,
    headerTheme = _ref5.headerTheme,
    gap = _ref5.gap,
    children = _ref5.children;
  return /*#__PURE__*/React.createElement("header", {
    className: cn('layout', "layout-theme--".concat(headerTheme), "layout__gap--".concat(gap), className, cnTheme('light')),
    "data-component": "site-header",
    role: "navigation"
  }, children);
};
Layout.Container = Container;
Layout.Section = Section;
Layout.Wrapper = Wrapper;
Layout.Indent = Indent;